import { jwtDecode } from 'jwt-decode' // import dependency

const decodeJwt = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    console.log(decoded)
    return true;
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return false;
  }
};

export { decodeJwt }
